import {useUser} from "./Permission";
import {orange} from "@mui/material/colors";
import {useProjectId} from "../pages/project/shopdrawing/ProjectName";
import {useIsQuote} from "../pages/project/quote/QuoteContainer";
import {api} from "../api/API";
import {useContext} from "react";
import {ConfirmContext} from "./Confirm";
import {useSnackbar} from "./Snackbar";
import {useNavigate} from "react-router-dom";

export function TestingBanner() {
    const u = useUser();

    if(!u) return null;
    if(u.isProductionEnv) return null;

    return (
        <div style={{width: "100%", padding: 4, textAlign: "center", backgroundColor: orange["800"], color: "white"}}>
            This is a testing environment
            <ResetProjectToQuoteMode />
        </div>
    )
}

function ResetProjectToQuoteMode() {
    const projectId = useProjectId();
    const isQuote = useIsQuote();
    const confirm = useContext(ConfirmContext);
    const snack = useSnackbar();
    const nav = useNavigate();

    if(projectId === 0) return null;
    if(isQuote) return null;

    return (
        <button style={{marginLeft: 12}} onClick={async () => {
            const ok = await confirm.confirm("Are you sure you want to reset this project to quote mode?");
            if(!ok) return;

            try {
                snack.loading();
                await api.projects.resetToQuoteMode({project: projectId})
                snack.success("Project reset to quote mode");
                nav(`/project/${projectId}`);
            } catch (e: any) {
                snack.error(e.toString())
            }
        }}>*Reset Project to Quote Mode*</button>
    )
}